import React, {PropTypes as T} from 'react';
import basketActions from '../../../../actions/basket';
import Button from '../../../common/button';
import InfoIcon from '../../../common/icons/icon_info';
import Tooltip from '../../../common/tooltip';
import {priceTypeToSlug, getDataAttributeSelectorString} from '../../../../utils/pricetype/pricetype_utils';
import TU from '../../../common/tu';
import OmnitureBuilder from '../../../../utils/omniture-helper/omniture_builder';
import {getPriceWithMandatoryUpsellsFormatted, mandatoryUpsellsString} from './utils';
import translate from '../../../../utils/translate';
import FEE_ROLLUP from '../../basket/recap/feerollup_states';
import {sprintf} from 'sprintf-js';
export default class NormalPriceType extends React.Component {
  static propTypes = {
    id: T.string,
    priceType: T.shape({
      name: T.string.isRequired,
      code: T.string.isRequired,
      isPasswordProtected: T.bool,
      additionalInfo: T.array
    }),
    price: T.shape({
      priceFormatted: T.string,
      priceType: T.string
    }),
    currency: T.string,
    mandatoryUpsells: T.array,
    moneyFormat: T.string,
    feeRollup: T.string
  };

  pickType = () => {
    basketActions.priceTypeToUnassignedSeat(this.props.id);
  };

  showInfoIcon = (priceType, price) => {
    return priceType.name &&
    priceType.additionalInfo &&
    priceType.additionalInfo.length > 0 ||
    priceType.name && price.priceInfo;
  };

  onInfoIconClick = () => {
    OmnitureBuilder.tmLinksNavlink('AdditionalInfo').sendSingle();
  };

  makeTooltipSelector = (priceType) => {
    const selector = priceTypeToSlug(priceType) + this.props.id;
    return getDataAttributeSelectorString('selector', selector);
  };

  renderAdditionalInfo = (priceType, price) => {
    let additionalInfoAndPriceComponents = [];

    priceType.additionalInfo.forEach(function (a)  {
      this.push(a);
    }, additionalInfoAndPriceComponents);

    if (price.priceInfo) {
      additionalInfoAndPriceComponents.push(price.priceInfo);
    }

    return (
        additionalInfoAndPriceComponents.map((section, index) => {
          if (section.content.length > 0) {
            return (
              <div className="tooltip__content" key={index}>
                <div className="tooltip__contentheader">
                  <TU text={section.title} />
                </div>
                <div className="tooltip__contentbody">
                  <TU text={section.content} />
                </div>
              </div>
            );
          }
          else {
            return false;
          }
        })
    );
  };

  render () {
    const {priceType, price, currency, mandatoryUpsells, moneyFormat, feeRollup} = this.props;
    const containerComponent = priceType.isPasswordProtected ? 'password-protected-pricetype' : 'pricetype';

    const priceWithMandatoryUpsellsFormatted = getPriceWithMandatoryUpsellsFormatted(this.props);

    let feeMessage = '';
    if (feeRollup !== FEE_ROLLUP.ROLLUP_SHOW_BREAKDOWN) {
      feeMessage = '';
    }
    else {
      const text = {
        ticketServiceFee: translate('ticketPriceInformationModule', 'TICKET_SERVICE_FEE'),
        serviceFeePrefix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_PREFIX'),
        serviceFeeSuffix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_SUFFIX'),
        and:              translate('eventInfoModule', 'AND'),
        currency:         currency
      };
      // format included charges (service fee)
      const maxTotal = price.includedCharge / 100;
      const decimalsMax = Math.round((maxTotal % 1) * 100);
      const sFString = sprintf(moneyFormat, maxTotal, decimalsMax, text.currency);
      // Generate service fee mesaage with text unit
      const serviceFeeMessage = translate('eventInfoModule', 'FEE_INCLUDED', {'%TICKET_FEE%': sFString});
      // Get Mandatory upsells message
      const mandatoryUpsellsStringMessage = mandatoryUpsellsString(price.priceType, mandatoryUpsells, text);

      // if no positive charges and no mandatory upsells than  set fee mesage to ''
      if (price.includedCharge === 0 && mandatoryUpsellsStringMessage === '') {
        feeMessage = '';
      }
      else {
        feeMessage = `(${serviceFeeMessage}${mandatoryUpsellsStringMessage})`;
      }
    }
    return (
      <div className="ismmodal__option" data-component={containerComponent}>
        <div className="ismmodal__option__label">
          <div className="ismmodal__option__label__title_container">
            <h3
              className="ismmodal__option__label__title"
              data-component="gapricetype-title">{priceType.name}</h3>
            {this.showInfoIcon(priceType, price) &&
            <a
              data-selector={priceTypeToSlug(priceType) + this.props.id}
              data-component="info-icon"
              className="ismmodal__option__additional_info_icon"
              tabIndex="0"
              role="button"
              onClick={this.onInfoIconClick}>
              <InfoIcon width={22} height={22} />
            </a>}
            {this.showInfoIcon(priceType, price) && <Tooltip selector={this.makeTooltipSelector(priceType)} >
              <div>{this.renderAdditionalInfo(priceType, price)}</div>
            </Tooltip>}
          </div>
          <span className="ismmodal__option__label__info" data-component="ismmodal_pricetype_feerollup">{feeMessage}</span>
        </div>
        <div className="ismmodal__option__control">
          <Button
            primary
            className="ismmodal__option__btn"
            onClick={this.pickType}
            data-component="pricetype-price">
            {priceWithMandatoryUpsellsFormatted}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/pricetypeselector/pricetype/normal_pricetype.js